import React from "react";
import StickyNote from "./StickyNote";
import EvidenceCard from "./EvidenceCard";
import CaseStamp from "./CaseStamp";

/** Loose notes pinned in the gaps between sections. Decorative: everything here is also filed on a real card. */
export const BoardScatter = () => (
  <div className="board-scatter" aria-hidden="true">
    <EvidenceCard variant="clipping" pin="red" rotate={-2.2} className="scatter scatter-clipping">
      <p className="clipping-kicker">The Case Times</p>
      <h3>Engineer ships UNICEF immunization tooling</h3>
      <p>Vue 3 interfaces. Firebase. Digital health pilots with DOH partners.</p>
    </EvidenceCard>

    <StickyNote color="pink" pin="brass" rotate={3} className="scatter scatter-chamly">
      <p className="hand">chamly is live</p>
      <p>wellness + money apps, built solo</p>
    </StickyNote>

    <StickyNote color="mint" rotate={-2.5} className="scatter scatter-ghl">
      <p className="hand">same M.O. every time</p>
      <p>build it → wire it up → make it run itself</p>
    </StickyNote>

    <StickyNote color="yellow" pin="red" rotate={2} className="scatter scatter-ops">
      <p className="hand">runs teams too</p>
      <p>see side file 06</p>
    </StickyNote>

    <CaseStamp tone="red" rotate={-10} className="scatter scatter-stamp">
      Evidence logged
    </CaseStamp>
  </div>
);

export default BoardScatter;
